import { combineReducers } from 'redux'
import resourceReducer from './resource'
import loading from './loading'
import references from './references'
import saving from './saving'

export default resources => {
  const resourceReducers = {}
  resources.forEach(resource => {
    resourceReducers[resource.name] = resourceReducer(resource.name, resource.options)
  })
  return combineReducers({
    ...resourceReducers,
    references,
    saving,
    loading,
  })
}



// WEBPACK FOOTER //
// ./state/reducers/rest.js